<template>
    <FormInputContainer class="FormDateInput" :inputId="`I${_uid}`" :label="label" :errors="errors">
        <FlatPickr
            :id="`I${_uid}`"
            v-bind="$attrs"
            :value="value"
            :config="config"
            @on-change="handleChange"
        />
    </FormInputContainer>
</template>


<script>
import FormInputContainer from './FormInputContainer';
import FlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    name: 'FormDateInput',
    inheritAttrs: false,

    components: { FlatPickr, FormInputContainer },

    props: {
        value: { type: String },
        label: { type: String },
        lazy: { type: Boolean, default: false },
        errors: { type: Array },
    },

    data: () => ({
        config: {
            dateFormat: 'M j, Y',
        },
    }),

    methods: {
        handleChange(event) {
            const date = event[0];
            this.$emit('input', date.toISOString());
        },
    },
}
</script>


<style lang="scss" scoped>
@import 'globals.scss';

.FormDateInput {
    input {
        @extend %form-control;
    }
}
</style>
